import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): NotificationsState => {
  return {
    pendingNotifications: null,
    dailyReminder: false,
    dailyReminderTime: null,
    inactiveReminder: false,
    inactiveReminderTime: null,
    nextWorkoutReminder: false,
    nextWorkoutReminderDate: null,
    notificationsEnabled: false,
    notificationsPermission: null,
    inactiveDays: 2,
    motivationalMessages: false,
    productAnnouncements: false,
    pushNotificationsPromptSeen: false,
  };
};

const notifications = (
  state = getInitialState(),
  action: ActionTypes
): NotificationsState => {
  switch (action.type) {
    case TypeKeys.SET_PENDING_NOTIFICATIONS: {
      const pending = action.pendingNotifications;
      let dailyReminder = false;
      let inactiveReminder = false;
      let nextWorkoutReminder = false;
      if (pending && pending.notifications) {
        pending.notifications.map((notification) => {
          if (notification.id == 1) {
            dailyReminder = true;
          } else if (notification.id == 2) {
            inactiveReminder = true;
          } else if (notification.id == 3) {
            nextWorkoutReminder = true;
          }
        });
      }
      return {
        ...state,
        pendingNotifications: action.pendingNotifications,
        dailyReminder,
        inactiveReminder,
        nextWorkoutReminder,
        nextWorkoutReminderDate: nextWorkoutReminder
          ? state.nextWorkoutReminderDate
          : null,
      };
    }
    case TypeKeys.SET_INACTIVE_DAYS: {
      return {
        ...state,
        inactiveDays: action.days,
      };
    }
    case TypeKeys.SET_NOTIFICATIONS_ENABLED: {
      return {
        ...state,
        notificationsEnabled: action.notificationsEnabled,
      };
    }
    case TypeKeys.SET_NOTIFICATIONS_PERMISSION: {
      return {
        ...state,
        notificationsPermission: action.notificationsPermission,
      };
    }
    case TypeKeys.SET_INACTIVE_REMINDER_TIME: {
      return {
        ...state,
        inactiveReminderTime: action.inactiveReminderTime,
        inactiveReminder: true,
      };
    }
    case TypeKeys.SET_DAILY_REMINDER_TIME: {
      return {
        ...state,
        dailyReminderTime: action.dailyReminderTime,
        dailyReminder: true,
      };
    }
    case TypeKeys.SET_NEXT_WORKOUT_REMINDER_DATE: {
      return {
        ...state,
        nextWorkoutReminderDate: action.nextWorkoutReminderDate,
        nextWorkoutReminder: true,
      };
    }
    case TypeKeys.TOGGLE_MOTIVATIONAL_MESSAGES: {
      return {
        ...state,
        motivationalMessages: action.motivationalMessages,
      };
    }
    case TypeKeys.TOGGLE_PRODUCT_ANNOUNCEMENTS: {
      return {
        ...state,
        productAnnouncements: action.productAnnouncements,
      };
    }
    case TypeKeys.PUSH_NOTIFICATIONS_PROMPT_SEEN: {
      return {
        ...state,
        pushNotificationsPromptSeen: true,
      };
    }
    case TypeKeys.SIGN_OUT: {
      return { ...getInitialState() };
    }
  }
  return state;
};

export default notifications;
